import type { FiltersValue } from '~features/dashboard-filters';

import type { SummaryFilter } from '~entities/summary';

import { getLocalDateWithOffset } from './get-local-date-with-offset';

export function filtersToParams({
  period,
  posIds,
  merchantIds,
}: FiltersValue): SummaryFilter {
  const { startDate, endDate } = period ?? {};

  return {
    dateTo: getLocalDateWithOffset(endDate ?? new Date()),
    dateFrom: getLocalDateWithOffset(startDate ?? new Date()),
    merchantIds,
    pointOfSalesIds: posIds,
  };
}
